import AdvertiserNavbar from '../../Advertiser/AdvertiserNavBar/AdvertiserNavBar'
import RatePitchesContent from './RatePitchesContent'

const RatePitches = ({ defaultAdminId}) => {

    document.title = 'Rate Pitches'

    return (
        <>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Rate Pitches</h1>
            </div>
            <RatePitchesContent defaultAdminId={defaultAdminId} />

        </>
    )
}

export default RatePitches
